import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
    BasicSelect
} from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
    name: 'UpdateNDR',
    components: {
        VueElementLoading,
        Treeselect,
        BasicSelect,
        PageTracker
    },
    mixins: [PageTracker],
    data: function () {
        return {
            ShippingID: '',
            ticketId: '',
            isLoading: false,
            shipmenttypeList: [{
                text: "Delivery"
            },],
            shipmenttypeObj: {
                text: ""
            },
            shipmenttype: '',
            processcode:'',
            NDRCode:'',
            oldstatuscode:'',
            NDRId:'',
            NDRList:[{
            text:"XBU00327- Customer Refused To Accept",
            value:"XBU00327"
            },
            {text:"XBU00467- Customer not available",
            value:"XBU00467"

            },
            {text:"XBU00472- Door step delivery not attempted",
            value:"XBU00472"

            },],
            NDRItemObj:{text: ""},
            NDRListFlt:[],
            NDR:'',
            Status:'',
        }
    },
    created: function () {
    },
    async mounted() {
        let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;
        //console.log('Mixin is working for :',result);
    },
    methods: {
        validateForm(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this.Update();
                }
            }).catch(() => {
                console.log('errors exist', this.errors)
            });
        },
        Update() {
            this.isLoading = true;
            let requestobj = {
                "ShippingId": this.ShippingID,
                "shipmenttype": this.shipmenttype,
                "LastModifiedBy":  this.localusermailid,
                 "Remark":this.ticketId,
                 "CorrectedNDR":this.NDR
            }
            axios({
                method: 'POST',
                url: apiUrl.api_url + 'websupport/update/ndr/npr/verification',
                data: requestobj
            })
                .then(async result => {
                    if (result.data.code == 200) {
                        let TrackerInfo = {
                            projectname:"Last Mile",
                            type: "Web",
                            userid: this.localuserid,
                            username: this.localusermailid,
                            meta: {
                                "event": "ndrVerification",
                                "ShippingId": this.ShippingID.toString(),
                                "shipmenttype": this.shipmenttype,
                                "Remark":this.ticketId,
                                "CorrectedNDR":this.NDR
                            }
                        }
                        this.PageTracker(TrackerInfo);
                        this.$alertify.success('Successfully Updated!!');
                    } else {
                        this.$alertify.error(result.data.message);
                    }
                    this.isLoading = false;
                    this.reset();
                })
        },
        selectshipmenttype(obj) {
            this.shipmenttypeObj = obj,
            this.shipmenttype = obj.text;
        },
          selectNDR(obj){
            this.NDRItemObj = obj
            this.NDR = obj.value
          },
        reset() {
            this.$validator.reset();
            this.ShippingID = '';
            this.isLoading = false;
            this.shipmenttypeObj = {};
            this.shipmenttype = '';
            this.ticketId = '';
            this.NDRItemObj = {};

        }
    }
}



// WEBPACK FOOTER //
// ./src/views/components/RemoveShipmentFromNDRVerification/RemoveShipmentFromNDRVerification.component.js